<template>
  <div class="loans-pipeline__container">
    <Conditions-Dashboard />
  </div>
</template>

<script>
import { Window } from "@progress/kendo-vue-dialogs"
import { Button } from "@progress/kendo-vue-buttons"
import auth from "../authConfig.js"
import axios from "axios"
import ConditionsDashboard from "../components/conditionCommand/ConditionsDashboard.vue"
import apiService from "../api/api.service.js"
import formatHelpers from "../helpers/formatHelpers.js"

export default {
  name: "ConditionOnlyDashboard",
  components: {
    window: Window,
    kbutton: Button,
    "Conditions-Dashboard": ConditionsDashboard
  },
  data() {
    return {
      conditionsData: [],
      selectedLoan: "",
      selectedLoanBorrower: "",
      selectedLoanNumber: "",
      isLoading: true,
      visible: true,
      isError: false,
      loaderStatus: "Logging In",
      loanChange: false,
      loandata: [],
      idTokenClaims: null
    }
  },
  async created() {
    const msalAppInstance = await auth.init()

    msalAppInstance.handleRedirectPromise().then(async tokenRes => {
      if (!tokenRes) {
        if (!auth.user()) {
          auth.login()
        }
      }
    })
  },
  methods: {}
}
</script>

<style scoped>
.loans-pipeline__container {
  height: 100vh;
  overflow: auto;
  flex: 1;
}
</style>
